import { OrderCrudTab, type OrderCrudConfig } from '@/components/OrderCrudTab'

const DELIVERY_CONFIG: OrderCrudConfig = {
  entity: '출고전표',
  entityDate: '출고일자',
  entityNo: '출고번호',
  partnerLabel: '거래처',
  specColLabel: '규격(원산지)',
  linesTitle: '출고 라인',
  searchPlaceholder: '출고번호, 거래처, 적요 검색',
  emptyText: '이 기간의 출고전표가 없습니다.',
  excelFilePrefix: '출고처리',

  apiBase: '/api/delivery',
  exportUrl: '/api/delivery/export',
  suggestUrl: '/api/delivery/suggest-price',
  queryKey: 'deliveries',

  unitField: 'unit_out',
  totalColorClass: 'text-blue-700',
  invoicePrint: true,  // 명세서 인쇄 (출고에서만)
  purchaseFields: true,  // 비고/선납/소분 열 (구매장 엑셀 반영)
  carryoverFlag: true,  // 등록화면 '이월' 체크 (매출관리 일일매출 다음달 이월)
  lineDateSplit: true,  // 선택 라인만 다른 출고일자로 분리
  excelImport: true,  // 엑셀(더존 출고 양식) 업로드로 전표 일괄 등록
  monthQtyRef: true,  // 펼침 상세에 이번달/저번달 출고수량 누계 참고열
  slimList: true,  // 목록은 라인 없이(건수만) 받아 대량 기간 페이로드 축소(라인은 펼침/수정 시 단건조회)
}

export function DeliveryTab() {
  return <OrderCrudTab config={DELIVERY_CONFIG} />
}
